<template>
  <div  id="app"  >
    <!--<resize-observer @notify="handleResize" />-->
      <I18nUpdater v-if="i18n != null" v-on:i18nChangeState="onI18nChangeState"  :i18nGroupName="i18nGroupName"> </I18nUpdater>
      <router-view v-if="i18n != null" ></router-view>
  </div>
</template>

<script>
import I18nUpdater from './sharedComponents/I18nUpdater.vue'
import { mapState } from 'vuex'
import NSS from './lib/nss-svg-animator'
import * as d3 from 'd3-selection'

export default {
  name: 'app',
  data () {
    return {
      i18nready: false,
      i18nGroupName: 'default'
    }
  },
  components: {
    I18nUpdater
  },
  computed: {
    ...mapState('i18n', {
      'i18n': state => state.i18n,
      'i18nLanguages': state => state.i18nLanguages
    }),
    ...mapState('default', {
      'callingAPI': state => state.callingAPI,
      'callingAPIMessage': state => state.callingAPIMessage
    })
  },
  methods: {
    handleResize () {
    },
    onI18nChangeState (value) {
      this.i18nready = value
    }
  },
  beforeMount () {
    this.$store.commit('i18n/SET_I18N', this.$i18n, { root: true })
    let rest = this.$route.fullPath.substring(3, this.$route.fullPath.length)
    if (rest === '') {
      rest = '/'
    }
    this.$router.push('/' + this.$i18n.locale + rest)
    // console.log(this.$i18n.locale)
    // this.$router.push('/' + this.$i18n.locale + '/')
    // toto if logged in
    // console.log(this.$route.fullPath)
  },
  mounted () {
    const renderer = NSS.AnimatorHelper.getRenderer('canvasCPU')
    renderer.autoResize = true
    NSS.AnimatorHelper.getAnimator().renderer = renderer
    d3.select('body').node().appendChild(renderer.canvas)
  }
}
</script>

<style  lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Lato');
  @import './node_modules/bootstrap/scss/bootstrap';
  @import 'scss/app';
  @include keyframes(pulse) {
    to {
      box-shadow: 0 0 0 5px rgba(35, 104, 166, 0);
    }
  }
  html {
    position: relative;
    height: 100%;
    min-height: 500px;
  }
  body {
    background-color: black;
    margin: 0;
    padding: 0;
    //overflow-y: scroll;
    font-size:16px;
    text-align:left;
    line-height:1.2;
    height:100%;
    font-size: 14px;
    canvas{
      position:absolute;
      top:0;
      left:0;
      pointer-events:none;
    }
  }

  @media only screen and (max-width: $phone-breakpoint) {
    html {
      min-height: 100%;
    }
    body {
      display: block;
      min-height: 100%;
      overflow: hidden;
    }
  }
  #app {
    font-family: 'Lato', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: black;
    height:100%;
  }
  .spinner {
    font-size:.7em;
    position:absolute;
    top:50%;
    left:50%;
    padding-left:10px;
    &.active {
      top:5px;
      right:10px;
      left:inherit;
    }
  }
  svg {
    filter: drop-shadow(0 0 4px rgba(0,0,0,.4));
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
  }
  @media only screen and (max-width: $default-breakpoint) {
    body {
      font-size:12px;
      line-height:1.2;
    }
  }
  @media only screen and (max-width: $phone-breakpoint) {
    body {
      font-size:14px;
      line-height:1.45;
    }
  }
</style>
